export const AUTH_COOKIE_NAME = "form-polls-token";
export const SELECTED_ORG_COOKIE_NAME = "form-selected-org";
